/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaymentIntentApiModel } from '../../models/payment-intent-api-model';
import { PaymentIntentResponseApiModel } from '../../models/payment-intent-response-api-model';

export interface CreatePaymentIntent$Params {
      body: PaymentIntentApiModel
}

export function createPaymentIntent(http: HttpClient, rootUrl: string, params: CreatePaymentIntent$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentIntentResponseApiModel>> {
  const rb = new RequestBuilder(rootUrl, createPaymentIntent.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaymentIntentResponseApiModel>;
    })
  );
}

createPaymentIntent.PATH = '/funds/create-payment-intent';
